module.exports = __webpack_public_path__ + "img/teachingmanagement_1.7bfde44e.jpg";